import { energy_certificate_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateEnergyCertificateTypeEnum = (enumValue: energy_certificate_type_enum) => {
  switch (enumValue) {
    case energy_certificate_type_enum.CONSUMPTION:
      return <Trans i18nKey="Enum_EnergyCertificateTypeEnum-CONSUMPTION" />;
    case energy_certificate_type_enum.DEMAND:
      return <Trans i18nKey="Enum_EnergyCertificateTypeEnum-DEMAND" />;
  }
};

export const translateEnergyCertificateTypeEnum_dynamic = (enumValue: energy_certificate_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case energy_certificate_type_enum.CONSUMPTION:
      return t('Enum_EnergyCertificateTypeEnum-CONSUMPTION');
    case energy_certificate_type_enum.DEMAND:
      return t('Enum_EnergyCertificateTypeEnum-DEMAND');
  }
};
